module.exports = require("./el-GR");